import { Link } from "react-router-dom";
import type { Team } from "@/mocks/teams";

interface TeamCardProps {
  team: Team;
}

export default function TeamCard({ team }: TeamCardProps) {
  return (
    <Link
      to={`/team/${team.id}`}
      className="group flex flex-col items-center rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 text-center transition-colors hover:border-primary-300 hover:bg-primary-50/40"
    >
      <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-background-100 flex items-center justify-center overflow-hidden p-2 transition-transform duration-500 group-hover:scale-105">
        <img
          src={team.crest}
          alt={`${team.name}队徽`}
          title={`${team.name} 欧冠球队资料`}
          className="w-full h-full object-contain"
        />
      </span>
      <h3 className="mt-3 text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
        {team.name}
      </h3>
      <p className="text-xs text-foreground-500 mt-0.5">{team.country}</p>
      <span className="mt-3 inline-flex items-center gap-1 rounded-full bg-background-100 px-2.5 py-0.5 text-[11px] text-foreground-600">
        <i className="ri-map-pin-line" aria-hidden="true"></i>
        {team.city}
      </span>
    </Link>
  );
}